'use client';

import { SubscriptionType } from '@prisma/client';
import Link from 'next/link';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

interface UpgradeToProProps {
	userSubscriptionType: SubscriptionType | undefined;
}

export function UpgradeToPro(props: UpgradeToProProps) {
	if (props.userSubscriptionType !== undefined && props.userSubscriptionType !== SubscriptionType.FREE) {
		return;
	}

	return (
		<div className='mt-auto w-full'>
			<Card>
				<CardHeader>
					<CardTitle>Upgrade to Pro</CardTitle>
					<CardDescription>
						Unlock all features and get unlimited access to our support team.
					</CardDescription>
				</CardHeader>
				<CardContent>
					<Link href='/upgrade' className='w-full'>
						<Button size='sm' className='w-full'>
							Upgrade
						</Button>
					</Link>
				</CardContent>
			</Card>
		</div>
	);
}
